/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "p--lg"
  }, React.createElement(_components.p, null, "The Google Calendar CRM integration generates a calendar feed that you can\nsubscribe to. By connecting Capsule to Google Calendar you can see your\nCapsule tasks side-by-side with your calendar events. This is useful for\nplanning your time and avoiding scheduling conflicts.")), "\n", React.createElement(_components.p, null, "\"Note: this is a view only calendar. New entries and updates need to be made in Capsule and they will be updated accordingly in your Google Calendar.\""));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
